import { Buttons } from './Buttons';
import { FileInput as FormFileInput } from './FileInput';
import { SelectOrCreate as FormSelectOrCreate } from './SelectOrCreate';
import { WrappedCheckbox as FormCheckbox } from './WrappedCheckbox';
import { WrappedDatePicker as FormDate } from './WrappedDatePicker';
import { WrappedDropdown as FormDropdown } from './WrappedDropdown';
import { WrappedDropdownPaginated as FormDropdownPaginated } from './WrappedDropdownPaginated';
import { WrappedInput as FormInput } from './WrappedInput';
import { WrappedMultipleDropdown as FormDropdownMultiple } from './WrappedMultipleDropdown';
import { WrappedRadio as FormRadio } from './WrappedRadio';
import { WrappedRangeInput as FormRange } from './WrappedRangeInput';
import { WrappedRatingInput as FormRating } from './WrappedRatingInput';
import { WrappedTextArea as FormTextArea } from './WrappedTextArea';
import { WrappedTimePicker as FormTime } from './WrappedTimePicker';
import { WrappedToggle as FormToggle } from './WrappedToggle';

export const Form = {
  FormInput,
  FormCheckbox,
  FormDropdown,
  FormDropdownPaginated,
  FormDropdownMultiple,
  FormDate,
  FormTime,
  Buttons,
  FormToggle,
  FormRadio,
  FormFileInput,
  FormRange,
  FormTextArea,
  FormRating,
  FormSelectOrCreate,
};

export type * from './types';
